import { ErrorHandler, Injectable } from '@angular/core';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';
import { ConstantConfigService } from './constant-config.service';
@Injectable({
  providedIn: 'root'
})
export class CustomErrorHandlerService implements ErrorHandler{
  _baseURL : string;
  private reportedErrors = new Set<string>();
  private lastErrorTimestamp = 0;
  private readonly ERROR_THROTTLE_TIME = 30000; // 30 seconds
   constructor(private http: HttpClient,private dataservice:DataService) {
    this._baseURL = ConstantConfigService.baseURL;
  }

  parseCookies(cookieStr: string): Record<string, string> {
    return cookieStr.split(';').reduce((acc: Record<string, string>, part: string) => {
      const [key, val] = part.trim().split('=');
      if (key && val) acc[key] = decodeURIComponent(val);
      return acc;
    }, {});
  }

  handleError(error:any) {

    const now = Date.now();

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    let chunkFailedMessage2 = 'ChunkLoadError: Loading chunk';
    chunkFailedMessage2 = chunkFailedMessage2.toString().toLowerCase();
    
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
    let ErrorMessage1 = error.message.toLowerCase();
    if(ErrorMessage1.indexOf(chunkFailedMessage2) > -1){
      window.location.reload();
    }
    console.log("===================Arvinderror=================",error,error.message);
    //console.log('Cookies from Angular:', document.cookie);

    const cookies = document.cookie;
    const parsedCookies = this.parseCookies(cookies);
    console.log('parsedCookies',parsedCookies);
    //super.handleError(error);
    let ErrorMessage = error.message;
    if(ErrorMessage.indexOf("ExpressionChangedAfterItHasBeenCheckedError") > -1 || ErrorMessage.indexOf("dtInstance") > -1){
      // No log error
    }else{
      const chunkFailedMessage = /Loading chunk [\d]+ failed/;

   

      if (chunkFailedMessage.test(error.message)) {
        window.location.reload();
      }
      var fullRoute = window.location.href;
      let errormessage = '';
      let errorstack = '';
      if (error instanceof TypeError) {
        errormessage += 'There was a Type error. '+ error.message;
        errorstack += error.stack;
      } else if (error instanceof Error) {
        errormessage += 'There was a general error. '+ error.message;
        errorstack += error.stack;
      } else {
          errormessage += 'some error happened!'+ error.message;
          errorstack += error.stack;
      }

      const key = `${errormessage}-${errorstack}`;

      if (!this.reportedErrors.has(key) && now - this.lastErrorTimestamp > this.ERROR_THROTTLE_TIME) {
        this.reportedErrors.add(key);
        this.lastErrorTimestamp = now;

        this.http.post(this._baseURL+"/log-frontend-error",{"path":fullRoute,"message":errormessage,"stack":errorstack, time: new Date().toISOString(), userAgent: navigator.userAgent,'parsedCookies':parsedCookies}).subscribe((res) => {});

      }

      //this.http.post(this._baseURL+"/log-frontend-error",{"path":fullRoute,"message":errormessage,"stack":errorstack}).subscribe((res) => {});
    }
    

  }
}
